import { render } from "./Welcome.vue?vue&type=template&id=54e3562c&scoped=true"
const script = {}

import "./Welcome.vue?vue&type=style&index=0&id=54e3562c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e3562c"]])

export default __exports__